import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserDetailsService } from 'src/app/service/user-details.service';

@Component({
  selector: 'app-derivative-header',
  templateUrl: './derivative-header.component.html',
  styleUrls: ['./derivative-header.component.css']
})
export class DerivativeHeaderComponent implements OnInit {
  fullscreen: boolean = true;
  user: any = {};

  @Output() derivativeChange = new EventEmitter<{ menuCode: string }>();

  constructor(private userDetailsService: UserDetailsService) { }

  ngOnInit(): void {
    this.user = this.userDetailsService.getUserDetails();
  }

  clicktoggle() {
    this.fullscreen = !this.fullscreen;
  }

  setDerivative(derivative) {
    this.derivativeChange.emit({ menuCode: derivative });
  }
}
